import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import { base_url } from 'Backend/api';
import { useNavigate } from 'react-router-dom';
import { getStoreRatingParts } from 'utils/storeRatingDisplay';
import { formatStoreTime12h } from 'utils/formatStoreTime';

const RestaurantHeader = ({ restaurant, isFavorite = false, favoriteLoading = false, onFavoriteToggle }) => {
  const navigate = useNavigate();
  const { averageFormatted, reviewsCount } = getStoreRatingParts(restaurant);
  return (
     <div className="w-full font-[cairo] mt-6">

      {/* IMAGE HEADER */}
      <div className="relative h-[120px]">

        <Image
          src={`${base_url}/storage/app/public/${restaurant?.media?.main_image}`}
          alt={restaurant?.name}
          className="w-full h-[120px] object-cover"
        />

        <button
          onClick={() => navigate(-1)}
          className="absolute top-4 right-4 bg-white p-2 rounded-full shadow z-20"
        >
          <Icon name="ArrowRight" size={18} />
        </button>

        <button
          type="button"
          onClick={onFavoriteToggle}
          disabled={favoriteLoading}
          className="absolute top-4 left-4 rounded-full bg-white p-2 shadow disabled:opacity-60"
          aria-label={isFavorite ? "إزالة من المفضلة" : "إضافة إلى المفضلة"}
        >
          <Icon
            name="Heart"
            size={18}
            color={isFavorite ? "#00B200" : "#9CA3AF"}
            fill={isFavorite ? "#00B200" : "none"}
          />
        </button>
      </div>

      {/* INFO */}
      <div className="bg-white px-4 py-3 flex items-center justify-between">

        <div className='flex flex-row'>
          {/* Rating */}
          <div className="bg-[#00C818] text-white px-1 py-0 rounded-[4px] text-sm font-bold text-center ml-4">
            <div className='flex flex-row items-center gap-1'>
              <img src='/assets/images/starrate.svg' className='h-4 w-4' alt="" />
              {averageFormatted}
            </div>
            <div className="text-[10px] font-medium">
              + {reviewsCount}
            </div>
          </div>

          {/* NAME + INFO */}
          <div className="text-right">
            <div className=" font-bold text-[15px]">
              {restaurant?.name}
            </div>

            <div className='flex flex-row gap-4 items-center'>
              <div className="text-[10px] text-gray-400 flex items-center gap-1">
                <Icon name="Clock" size={12} />
                <span>
                  {formatStoreTime12h(restaurant?.timing?.opens_at)} - {formatStoreTime12h(restaurant?.timing?.closes_at)}
                </span>
              </div>

              <div className="text-xs text-gray-500">
                {restaurant?.type}
              </div>
            </div>
          </div>
        </div>

      </div>

      

    </div>
  );
};

export default RestaurantHeader;